import Container from "../Container";
import {useRouter} from "next/router";
import localized from "../../locale/locales";

export default function SectionQuestions({className = '', children}) {
    const {locale} = useRouter();
    const {sections: {questions: lang}, common} = localized[locale];

    return (
        <Container className={`relative text-center md:pt-32 pb-16 md:pb-24 ${className}`}>
            <header className="mb-8">
                {children}
            </header>
            <p className="max-w-[28ch] leading-[1.6] mx-auto mb-10">
                {lang.body}
            </p>
            <a href={`mailto:${common.email}`}
               className="text-lg md:text-[32px] leading-none underline mouse-hover:no-underline text-accent-color font-semibold inline-flex"
            >
                {common.email}
            </a>
        </Container>
    )
}